import { gettext } from '@eventbrite/i18n';
import React from 'react';

type Props = {
    eventId: string;
};

export const CreatorBanner = ({ eventId }: Props) => {
    return (
        <div
            className="eds-notification-bar eds-notification-bar eds-notification-bar--neutral"
            role="alert"
        >
            <div className="eds-notification-bar__content">
                <div className="eds-notification-bar__content-child eds-g-cell">
                    {gettext('Need to make some updates?')}{' '}
                    <a
                        href={`/myevent?eid=${eventId}`}
                        target="_blank"
                        id="edit-event"
                        rel="noopener noreferrer"
                    >
                        {gettext('Edit event')}
                    </a>
                </div>
            </div>
        </div>
    );
};
